import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

class DrippingInput extends Component {
  state = {
    value: 0,
    valid: true,
  };

  componentDidMount() {
    const { value } = this.props;
    if (value !== '') {
      this.setState({
        value,
      });
    }
  }

  handleDripInputChange = () => {
    const { value, valid } = this.state;
    const { onChange } = this.props;
    onChange(valid ? Number(value.trim()) : -1);
  };

  onInputChange = (e) => {
    const { value = '' } = e.target;
    const valid = value !== '' && !isNaN(value) && value >= 0;
    this.setState({
      value,
      valid,
    }, this.handleDripInputChange);
  };

  isValid = () => {
    const { value } = this.state;
    return value !== '' && !isNaN(value);
  };

  render() {
    const { value, valid } = this.state;
    return (
      <DripInput
        type="number"
        className="drip-input-delay"
        value={value}
        min="0"
        onChange={this.onInputChange}
        errored={!valid}
      />
    );
  }
}

const DripInput = styled.input`
  ${props => props.errored ? 'border: 1px solid #F44336 !important;' : ''}
`;

DrippingInput.propTypes = {
  value: PropTypes.number,
  onUpdate: PropTypes.func,
};

DrippingInput.defaultProps = {
  value: {},
  onUpdate: () => {},
};

export default DrippingInput;
